import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space10, colorBgBase } = theme();

  return StyleSheet.create({
    layoutContainer: {
      backgroundColor: colorBgBase,
      display: "flex",
      justifyContent: "center",
    },
    wrapper: {
      maxWidth: 1280,
      paddingHorizontal: space10,
      width: "100%",
    },
  });
};

export { style };
